var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HIGHEST_VOLUME, HIGHEST_VOLUME_STREAM, } from "../../../interface/drivingMarket/highestVolume/highestVolume";
import { drivingMarketOptionsStream } from "@domains/features/Markets/Options/utils/streamUpdate";
var initState = {
    data: {},
};
var HighestVolume = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case HIGHEST_VOLUME:
            return __assign(__assign({}, state), { data: action.payload.data });
        case HIGHEST_VOLUME_STREAM:
            return __assign(__assign({}, state), { data: drivingMarketOptionsStream(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default HighestVolume;
